import { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

class Logout extends Component {
  static defaultProps = {
    onLogout: () => null,
  };

  static propTypes = {
    onLogout: PropTypes.func,
    router: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { onLogout, router } = this.props;
    onLogout();
    router.push('/');
  }

  render() {
    return null;
  }
}

export default withRouter(Logout);



// WEBPACK FOOTER //
// ./src/modules/auth/components/Logout/Logout.state.jsx